import problema01 from "./cartas/problema-01.webp";
import problema02 from "./cartas/problema-02.webp";
import problema03 from "./cartas/problema-03.webp";
import problema04 from "./cartas/problema-04.webp";
import problema05 from "./cartas/problema-05.webp";
import problema06 from "./cartas/problema-06.webp";
import problema07 from "./cartas/problema-07.webp";
import problema08 from "./cartas/problema-08.webp";
import problema09 from "./cartas/problema-09.webp";
import problema10 from "./cartas/problema-10.webp";
import raroAjuda from "./cartas/raro-ajuda.webp";
import raroAmeaca from "./cartas/raro-ameaca.webp";
import solucao01 from "./cartas/solucao-01.webp";
import solucao02 from "./cartas/solucao-02.webp";
import solucao03 from "./cartas/solucao-03.webp";
import solucao04 from "./cartas/solucao-04.webp";
import solucao05 from "./cartas/solucao-05.webp";
import solucao06 from "./cartas/solucao-06.webp";
import solucao07 from "./cartas/solucao-07.webp";
import solucao08 from "./cartas/solucao-08.webp";
import solucao09 from "./cartas/solucao-09.webp";
import solucao10 from "./cartas/solucao-10.webp";

// As 22 cartas do NORTE / Amazônia — o dado, separado do descritor.
//
// 20 comuns (10 problemas + 10 soluções, textos aprovados em
// Cards_Curiosidade_Amazonia.md, verbatim) e 2 raras, que formam o arco narrado pela
// Onça-pintada — no FEMININO, e isso não é estilo: "não estou sozinha", no card de
// ajuda, depende disso.
//
// O NOME DO ARQUIVO É O ID, sem o prefixo da região (a pasta já é a região). Não é
// estética: `card_id` é a CHAVE da coleção do aluno em
// `activity_ludic_trail_collection` e não se renomeia depois de gravada, enquanto um
// slug descritivo ("desmatamento-carvao") pode envelhecer se o texto mudar de
// assunto. Com o id no nome do arquivo, os dois não têm como divergir — e o caminho
// da arte passa a ser DERIVÁVEL do id, o que apagou a convenção de nome que vivia
// duplicada em três lugares (o catálogo Python, ferramentas-diagnostico e aqui).
//
// Sem campo `fase`: a posição na trilha vem do sorteio, não é intrínseca ao card.

// Banco fixo de 20: o sorteio tira 4 por trilha sem repetir (ver
// ava/progressoDoAluno.js), e o tamanho do banco é o que dá chance de carta nova
// quando o aluno refaz.
export const CARDS_COMUNS_NORTE = [
  {
    id: "norte-problema-01",
    tipo: "problema",
    nome: "Desmatamento pra Pasto",
    asset: problema01,
    pilula:
      "Quando a floresta amazônica vira pasto pro gado, a onça-pintada perde a mata fechada onde caça e se esconde à espreita da presa."
  },
  {
    id: "norte-problema-02",
    tipo: "problema",
    nome: "Queimadas",
    asset: problema02,
    pilula:
      "O fogo usado pra abrir clareiras foge de controle e destrói de uma vez a floresta onde a onça-pintada se move e caça em silêncio."
  },
  {
    id: "norte-problema-03",
    tipo: "problema",
    nome: "Fragmentação de Habitat",
    asset: problema03,
    pilula:
      "Estradas e fazendas cortam a floresta em pedaços cada vez menores, isolando a onça-pintada em áreas pequenas demais pro tamanho do seu território."
  },
  {
    id: "norte-problema-04",
    tipo: "problema",
    nome: "Conflito com Pecuaristas",
    asset: problema04,
    pilula:
      "Quando ataca gado por falta de presas naturais, a onça-pintada é caçada de vingança por criadores — um conflito que só diminui sua população."
  },
  {
    id: "norte-problema-05",
    tipo: "problema",
    nome: "Garimpo Ilegal",
    asset: problema05,
    pilula:
      "O mercúrio jogado nos rios pelo garimpo ilegal contamina os peixes e os bichos que servem de alimento pra onça-pintada."
  },
  {
    id: "norte-problema-06",
    tipo: "problema",
    nome: "Caça e Tráfico",
    asset: problema06,
    pilula:
      "Presa de contrabandistas, a onça-pintada é caçada pela pele e pelos dentes, um comércio ilegal que ameaça direto sua sobrevivência."
  },
  {
    id: "norte-problema-07",
    tipo: "problema",
    nome: "Estradas na Floresta",
    asset: problema07,
    pilula:
      "Estradas abertas dentro da mata fragmentam o território da onça-pintada e transformam sua travessia num risco de atropelamento."
  },
  {
    id: "norte-problema-08",
    tipo: "problema",
    nome: "Caça das Presas",
    asset: problema08,
    pilula:
      "A caça excessiva de queixadas e veados tira da onça-pintada o alimento que ela precisa pra sobreviver na floresta."
  },
  {
    id: "norte-problema-09",
    tipo: "problema",
    nome: "Hidrelétricas",
    asset: problema09,
    pilula:
      "Grandes represas alagam áreas enormes de floresta, destruindo de uma vez o território de caça da onça-pintada."
  },
  {
    id: "norte-problema-10",
    tipo: "problema",
    nome: "Secas na Amazônia",
    asset: problema10,
    pilula:
      "Secas cada vez mais fortes reduzem os rios e a água disponível, dificultando a vida da onça-pintada e das presas de que ela depende."
  },
  {
    id: "norte-solucao-01",
    tipo: "solucao",
    nome: "Corredores Ecológicos",
    asset: solucao01,
    pilula:
      "Plantar faixas de floresta nativa reconecta pedaços de mata separados, dando à onça-pintada espaço suficiente pra caçar e se reproduzir."
  },
  {
    id: "norte-solucao-02",
    tipo: "solucao",
    nome: "Fiscalização Ambiental",
    asset: solucao02,
    pilula:
      "Fiscalizar e punir o desmatamento ilegal mantém de pé a floresta que a onça-pintada precisa pra viver."
  },
  {
    id: "norte-solucao-03",
    tipo: "solucao",
    nome: "Aceiros e Brigadas",
    asset: solucao03,
    pilula:
      "Conter o fogo antes que se espalhe protege a mata fechada onde a onça-pintada se esconde e caça."
  },
  {
    id: "norte-solucao-04",
    tipo: "solucao",
    nome: "Manejo do Rebanho",
    asset: solucao04,
    pilula:
      "Cercar pastos e proteger o gado à noite evita ataques da onça-pintada aos animais — e evita que ela seja caçada de vingança."
  },
  {
    id: "norte-solucao-05",
    tipo: "solucao",
    nome: "Combate ao Garimpo Ilegal",
    asset: solucao05,
    pilula:
      "Impedir o garimpo ilegal mantém os rios limpos e os peixes disponíveis pras presas de que a onça-pintada se alimenta."
  },
  {
    id: "norte-solucao-06",
    tipo: "solucao",
    nome: "Combate ao Tráfico",
    asset: solucao06,
    pilula:
      "Fiscalizar e denunciar o tráfico de peles e dentes é a forma mais direta de proteger a onça-pintada da extinção."
  },
  {
    id: "norte-solucao-07",
    tipo: "solucao",
    nome: "Passagens de Fauna",
    asset: solucao07,
    pilula:
      "Viadutos e túneis pra animais permitem que a onça-pintada atravesse estradas sem risco de ser atropelada."
  },
  {
    id: "norte-solucao-08",
    tipo: "solucao",
    nome: "Proteção das Presas",
    asset: solucao08,
    pilula:
      "Regras pra caça de subsistência garantem que queixadas e veados continuem existindo na floresta pra alimentar a onça-pintada."
  },
  {
    id: "norte-solucao-09",
    tipo: "solucao",
    nome: "Áreas Protegidas",
    asset: solucao09,
    pilula:
      "Terras indígenas e unidades de conservação viram um refúgio seguro onde a onça-pintada pode viver sem ameaças."
  },
  {
    id: "norte-solucao-10",
    tipo: "solucao",
    nome: "Monitoramento e Ciência",
    asset: solucao10,
    pilula:
      "Câmeras escondidas na mata ajudam cientistas a estudar a onça-pintada — e quanto mais gente conhece sua luta, mais gente ajuda a protegê-la."
  }
];

// Fora do sorteio: o arco do mascote, em 1ª pessoa. A ORDEM importa, e o casamento
// é ALINHADO PELO FIM (ver nucleo/recompensaDaFase.js) — numa trilha de 2 a 4 passos
// existe uma fase rara só, e ela tem de receber o FECHO. O último item é o único que
// todo aluno vê, e o único com `comemorar: true`.
export const CARDS_RAROS_NORTE = [
  {
    id: "norte-raro-ameaca",
    tipo: "raro",
    nome: "A Amazônia em Perigo",
    asset: raroAmeaca,
    pilula:
      "Ai, ai... minha floresta está encolhendo: abrem estradas, ateiam fogo pro pasto, e ainda tem quem me caça pela pele. Continue a exploração pra me ajudar a proteger meu território!"
  },
  {
    id: "norte-raro-ajuda",
    tipo: "raro",
    nome: "Vamos Cuidar da Amazônia!",
    asset: raroAjuda,
    comemorar: true,
    pilula:
      "Graças a você, aprendi que não estou sozinha: cada árvore de pé e cada rio limpo ampliam o território onde eu vivo. Continue de olho na natureza — cuidar da floresta também é cuidar de você!"
  }
];

export const CARDS_NORTE = [...CARDS_COMUNS_NORTE, ...CARDS_RAROS_NORTE];
